'use strict';
exports.__esModule = true;
var tree_filter_1 = require("./tree-filter");
var filter_logic_1 = require("../../../../report-options2/filter-logic");
function formatTreeviewFilterHeader(filterLogicStr) {
    var filterLogicArr = filterLogicStr.split(' ');
    var headerArr = filterLogicArr.map(function (f) {
        if (f.split(':').length !== 3) {
            return f;
        }
        var _a = f.split(':'), key = _a[0], codedVal = _a[1], codedName = _a[2];
        if (f.startsWith('(')) {
            return '((' + atob(decodeURIComponent(codedName)) + ':' + atob(decodeURIComponent(codedVal)) + ')';
        }
        if (f.endsWith(')')) {
            return '(' + atob(decodeURIComponent(codedName).slice(0, -1)) + ':' + atob(decodeURIComponent(codedVal)) + '))';
        }
        return '(' + atob(decodeURIComponent(codedName)) + ':' + atob(decodeURIComponent(codedVal)) + ')';
    });
    return headerArr.join(' ');
}
var treewidget;
(function (treewidget) {
    /**
     * Define the structure of a template.
     */
    var Template = /** @class */ (function () {
        /**
         * Create a template with fixed structure. Explictly shows the
         * structure of a template.
         *
         * @param name {string} Template display name.
         * @param isPlatform {boolean} Platform true, leaf false.
         * @param info {object} An object, useless here.
         */
        function Template(name, isPlatform, info) {
            this.name = name;
            this.hasPlatform = isPlatform;
            this.info = info;
        }
        return Template;
    }());
    treewidget.Template = Template;
    /**
     * Define the structure of search result.
     */
    var SearchResult = /** @class */ (function () {
        /**
         * Create a new search result object.
         *
         * @param key {string} Keyword use to search in tree.
         * @param total {number} Total number of matches in current search.
         * @param index {number} Current result index in search.
         * @param nodes {Array<TreeNode>} The result nodes.
         */
        function SearchResult(key, total, index, nodes) {
            this.searchKey = key;
            this.totalMatch = total;
            this.resultIndex = index;
            this.resultNodes = nodes;
        }
        return SearchResult;
    }());
    treewidget.SearchResult = SearchResult;
    /**
     * <b>Note:</b> All manipulations on data should be done in back
     * end.
     */
    var JsonTree = /** @class */ (function () {
        //================================
        // Initializations
        //================================
        /**
         * Initialize a tree object. This object holds the tree
         * information and other related information. Some tree
         * manipulation should also be built in this class.
         *
         * @param {TreeNode} treeData Json data of the tree. The tree
         *     is built in json format, following the structure of json
         *     string. However, the input json string should have the
         *     essential keys defined in TreeNode interface.
         * @param {number} defaultExpandLevel The tree will expand to
         *     this level initially. Root is 0, and so on.
         */
        function JsonTree(treeData, defaultExpandLevel) {
            if (treeData) {
                this.treeData = treeData;
                this.treeName = treeData.name;
            }
            this.defaultExpandLevel = defaultExpandLevel;
            this.initialTreeExpand(this.treeData, 0);
            this.nodeMap = {};
            this.buildNodeMap(this.treeData);
            this.templateMap = {};
            this.templateList = [];
            this.currentExcludedFilterTags = [];
        }
        Object.defineProperty(JsonTree.prototype, "rootNode", {
            get: function () {
                return this.treeData;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Reload the tree data, but keep the expanding status.
         *
         * @param treeData New tree data. Most nodes should be the
         *     same as original.
         */
        JsonTree.prototype.reloadTree = function (treeData) {
            this.treeData = treeData;
            this.buildNodeMap(this.treeData);
        };
        /**
         * Initilize a tree start from certain node, with a default
         * expand level from this node. No going through the whole
         * tree, because we only need to set the expanded nodes. The
         * others just left them alone.
         *
         * @param {TreeNode} startNode The node to start expand. in the
         *     initial stage, should always use root.
         * @param {number} currentLevel The level of current node. If
         *     this value is lower than default expand level, current
         *     node will be set as collapsed.
         */
        JsonTree.prototype.initialTreeExpand = function (startNode, currentLevel) {
            if (currentLevel < this.defaultExpandLevel && startNode && startNode.children.length > 0) {
                startNode["expanded"] = true;
                for (var i = 0; i < startNode.children.length; i++) {
                    this.initialTreeExpand(startNode.children[i], currentLevel + 1);
                }
            }
            else {
                startNode["expanded"] = false;
            }
        };
        //================================
        // Map and search
        //================================
        /**
         * Build a map of all nodes by a preorder traversal. Also build
         * a two way linked list to handle searching.
         *
         * @param {TreeNode} root Recurse through all nodes.
         */
        JsonTree.prototype.buildNodeMap = function (root) {
            if (!root) {
                return;
            }
            var tempMap = this.nodeMap;
            this.nodeMap = {};
            var stack = [];
            stack.push(root);
            var currentNode;
            var lastNode = null;
            while (stack.length) {
                currentNode = stack.pop();
                // Keep current expand status
                var nodeLazyArchive = currentNode.childrenIds && currentNode.childrenIds.length > 0 && (currentNode.children.length == 0 && !currentNode.loading);
                if (tempMap[currentNode._id] && !nodeLazyArchive) {
                    currentNode.expanded = tempMap[currentNode._id].expanded;
                }
                this.nodeMap[currentNode._id] = currentNode;
                if (lastNode) {
                    currentNode.previous = lastNode;
                    lastNode.next = currentNode;
                }
                lastNode = currentNode;
                for (var i = currentNode.children.length - 1; i > -1; i--) {
                    stack.push(currentNode.children[i]);
                }
            }
            // root and last
            currentNode.next = root;
            root.previous = currentNode;
        };
        /**
         * Remove items from node map recursively. Start from given
         * node, remove all child nodes from map including itself.
         * Update the two way linked list on deleting.
         *
         * @param node Recurse through all subnodes.
         * @returns {boolean} False if input is empty. Otherwise
         *     True.
         */
        JsonTree.prototype.removeFromMap = function (node) {
            if (node) {
                node.next.previous = node.previous;
                node.previous.next = node.next;
                delete this.nodeMap[node._id];
                for (var i = 0; i < node.children.length; i++) {
                    this.removeFromMap(node.children[i]);
                }
                return true;
            }
            else {
                return false;
            }
        };
        /**
         * Search the tree by a keyword.
         *
         * @param selectedNode {TreeNode} Currently selected tree node.
         *     Search starts from next/previous node and ends in this.
         *     If no node is selected, start from root (included).
         * @param key {string} Key word to search, can be empty, which
         *     means every node will match.
         * @param direction {number} Any value >= 0 means search next,
         *     otherwise search previous.
         * @returns {SearchResult} Result object including total number
         *     of matches, index of result and result node.
         */
        JsonTree.prototype.searchNode = function (selectedNode, key, direction) {
            var matchedNodes = [];
            var totalMatch = 0;
            var index = 1;
            /**
             * The next searching result.
             * @type {TreeNode}
             */
            var result = undefined;
            // If no node is selected, go to the root node.
            if (!selectedNode || !this.nodeMap[selectedNode._id]) {
                selectedNode = direction >= 0 ? this.treeData.previous :
                    this.treeData;
            }
            // Set searching direction and start point.
            var loopNode = selectedNode;
            do {
                loopNode = direction >= 0 ? loopNode.next : loopNode.previous;
                if (!loopNode.hide && loopNode.name.toLowerCase().indexOf(key.toLowerCase()) > -1) {
                    result = loopNode;
                    break;
                }
            } while (loopNode._id != selectedNode._id);
            if (result) {
                // Get index and total matches.
                var countNode = this.treeData;
                do {
                    if (!countNode.hide && countNode.name.toLowerCase().indexOf(key.toLowerCase()) > -1) {
                        matchedNodes.push(countNode);
                        totalMatch++;
                        if (countNode._id == result._id) {
                            index = totalMatch;
                        }
                    }
                    countNode = countNode.next;
                } while (countNode._id != this.treeData._id);
                this.expandBranch(result._id);
                return new SearchResult(key, totalMatch, index, matchedNodes);
            }
            else {
                return null;
            }
        };
        //================================
        // Tree Manipulation
        //================================
        /**
         * Check if a new id is available in this tree. If input
         * already exists in map, return false.
         *
         * Empty id means a new unique id will be generated.
         *
         * @param {string} id New id to check.
         * @returns {boolean} False if empty or id exists. Otherwise
         *     True.
         */
        JsonTree.prototype.checkIdAvailability = function (id) {
            return id ? !(id in this.nodeMap) : true;
        };
        /**
         * Create a child node for specific node. This function
         * enforced id check, so it will make sure no duplicated id
         * exists. User may call create node function from tree-node,
         * but that one does not considering unique id.
         *
         * @param {string} parentId The new created node will be the
         *     last child of this node.
         * @param {string} id Id of the new node. If leave blank, a
         *     unique id will be generated.
         * @param {string} name Display name of the new node. This name
         *     must pass the conflict check.
         * @param {string} isPlatform True if this node is platform.
         * @param {string} templates A list of template names of this
         *     node.
         * @param {Array<string>} tags A list of tags.
         * @param {Array<string>} dropdownTags A list of dropdownTags.
         *
         * @returns {boolean} True if a node is successfully created
         *     and added to the node.
         */
        JsonTree.prototype.createChildNode = function (parentId, id, name, isPlatform, templates, path, tags, dropdownTags) {
            if (!(parentId in this.nodeMap)) {
                return false;
            }
            var parent = this.nodeMap[parentId];
            if (this.checkIdAvailability(id) &&
                parent.checkChildrenNameAvailability(name)) {
                var rs = parent.createNewNodeAsChild(id, name, isPlatform, templates, path, tags, dropdownTags);
                if (rs) {
                    parent.expanded = true;
                    for (var i = 0; i < parent.children.length; i++) {
                        this.nodeMap[parent.children[i]._id] =
                            parent.children[i];
                    }
                    this.buildNodeMap(this.treeData);
                }
                return rs;
            }
            return false;
        };
        /**
         * Edit a node. Enforce sibling name confliction checking.
         * Note: Need to consider template modification, but for the
         * node in the tree, seems nothing to do with template.
         *
         * @param {string} nodeId Change name of this node.
         * @param {string} newName New name.
         * @param {Array<string>} children New order of children for
         *     current node.
         * @returns {boolean} True if change successfully. False
         *     Otherwise.
         */
        JsonTree.prototype.editNode = function (nodeId, newName, children) {
            if (!(nodeId in this.nodeMap)) {
                return false;
            }
            var node = this.nodeMap[nodeId];
            if (children && children.length) {
                if (node.arrageChildren(children)) {
                    this.reloadTree(this.treeData);
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                return node.editNode(newName);
            }
        };
        /**
         * Update current node tags and parent node tags upon editing a node.
         *
         * @param {any} tagsData Array of tagString with nodeID
         *
         */
        JsonTree.prototype.updateTags = function (tagsData) {
            var ctrl = this;
            tagsData.map(function (_a) {
                var nodeId = _a[0], tagStr = _a[1];
                if ('nodeId' in ctrl.nodeMap) {
                    ctrl.nodeMap[nodeId].tags = tagStr.split(',');
                    ctrl.nodeMap[nodeId].tagString = tagStr;
                }
            });
        };
        JsonTree.prototype.addNodeNameCheck = function (nodeId, newName) {
            if (!(nodeId in this.nodeMap)) {
                return false;
            }
            return this.nodeMap[nodeId].checkChildrenNameAvailability(newName);
        };
        JsonTree.prototype.editNodeNameCheck = function (nodeId, newName) {
            if (!(nodeId in this.nodeMap)) {
                return false;
            }
            return this.nodeMap[nodeId].checkNodeNameAvailability(newName);
        };
        /**
         * Delete a node, also update node map. If root is deleted,
         * clean the other related properties too.
         *
         * @param {string} nodeId This node will be delete, if it
         *     exists.
         * @returns {boolean} True if the node exists and got deleted.
         *     False otherwise.
         */
        JsonTree.prototype.deleteNode = function (nodeId) {
            if (!(nodeId in this.nodeMap)) {
                return false;
            }
            var node = this.nodeMap[nodeId];
            if (!node.parent) {
                this.treeData = undefined;
                this.nodeMap = {};
                return true;
            }
            else {
                this.nodeMap[node.parent._id].deleteChildNode(nodeId);
                this.removeFromMap(node);
                return true;
            }
        };
        /**
         * Check if a node is root node or not.
         *
         * @param {string} nodeId This node will be delete, if it
         *     exists.
         * @returns {boolean} True if the node has no parent.
         *     False otherwise.
         */
        JsonTree.prototype.isRoot = function (nodeId) {
            var node = this.nodeMap[nodeId];
            return !node.parent;
        };
        /**
         * Check if node 2 is an ancester of node 1.
         *
         * @param {TreeNode} srcNode This is the child node.
         * @param {TreeNode} tgtNode Check if this node is an ancester.
         * @returns {boolean} True if it is an ancester, false
         *     otherwise.
         */
        JsonTree.prototype.isAncester = function (srcNode, tgtNode) {
            var rs = false;
            var node = srcNode;
            while (node && !rs) {
                if (node.parent._id != tgtNode._id) {
                    node = this.nodeMap[node.parent._id];
                }
                else {
                    rs = true;
                }
            }
            return rs;
        };
        /**
         * Move (Cut/Paste) node to somewhere else. Notice: cannot move
         * node into its own subtree.
         *
         * [NOT USED]
         *
         * @param {string} nodeId Node to move.
         * @param {string} newParentId Will be put as a subnode of this
         *     one.
         * @returns {boolean} True if success, otherwise false. False
         *     may caused by unexisted node or pasting to own subtree.
         */
        JsonTree.prototype.moveNode = function (nodeId, newParentId) {
            if (!(nodeId in this.nodeMap) || !(newParentId in this.nodeMap)) {
                return false;
            }
            var node = this.nodeMap[nodeId];
            var newParent = this.nodeMap[newParentId];
            if (node.parent._id == newParent._id ||
                this.isAncester(newParent, node)) {
                return false;
            }
            if (!newParent.checkChildrenNameAvailability(node.name)) {
                return false;
            }
            this.nodeMap[node.parent._id].deleteChildNode(nodeId);
            newParent.addNodeAsChild(node);
            node.parent = this.nodeMap[newParentId];
            newParent.expanded = true;
            return true;
        };
        /**
         * Expand a certain node by node id.
         *
         * @param {string} nodeId Node id, not display name.
         */
        JsonTree.prototype.expandNode = function (nodeId) {
            if (this.nodeMap[nodeId]) {
                this.nodeMap[nodeId].expanded = true;
            }
            else {
                this.initialTreeExpand(this.treeData, 0);
            }
        };
        /**
         * Expand every node on the path from root to this node.
         *
         * @param {string} nodeId
         */
        JsonTree.prototype.expandBranch = function (nodeId) {
            var node = this.nodeMap[nodeId];
            var path = [];
            while (node.parent) {
                node = this.nodeMap[node.parent._id];
                path.push(node);
            }
            // Did this because of ng-if dependency.
            while (path.length) {
                path.pop().expanded = true;
            }
        };
        //================================
        // Platform and templates
        //================================
        /**
         * Transform the template list object, check is there is any
         * change. If there is no change, the templateList will not be
         * updated to avoid extra loading on list.
         *
         * @param templates {Array<any>} A list of template obtained
         *     from server. Should at least contain name and
         *     hasPlatform.
         */
        JsonTree.prototype.setTemplate = function (templates) {
            // keep only the new ones in case some templates are deleted.
            var tempMap = {};
            var tempList = [];
            // update template map and check changes.
            var different = templates.length != this.templateList.length;
            var i;
            for (i = 0; i < templates.length; i++) {
                // if not exists, or
                // if exists but different
                if (different || !this.templateMap[templates[i].name] ||
                    this.templateMap[templates[i].name].hasPlatform !=
                        templates[i].hasPlatform) {
                    different = true;
                    break;
                }
            }
            // only update when there is difference
            if (different) {
                for (i = 0; i < templates.length; i++) {
                    tempMap[templates[i].name] = new Template(templates[i].name, templates[i].hasPlatform, templates[i].info);
                    tempList.push(tempMap[templates[i].name]);
                }
                this.templateMap = tempMap;
                this.templateList = tempList;
            }
        };
        JsonTree.prototype.filterTree = function (filterLogicStr) {
            if (filterLogicStr === void 0) { filterLogicStr = ''; }
            var treeHide = false;
            var allTags = this.treeData.tags;
            var allDropdownTags = this.treeData.dropdownTags;
            var validTags = (allTags ? allTags.filter(function (t) { return t.includes(':'); }) : []).concat(allDropdownTags ? allDropdownTags.filter(function (t) { return t.split(':').length == 3; }) : []);
            var filterLogic = filter_logic_1.createFilterLogic(filterLogicStr);
            if (filterLogic) {
                // filterLogic.filter(new Set(validTags));
                this.currentFilterLogic = filterLogic.toExp();
                var filterBy = tree_filter_1.getFilterBy(this.currentFilterLogic);
                var filterTags_1 = [];
                for (var _i = 0, _a = Object.entries(filterBy.tags); _i < _a.length; _i++) {
                    var _b = _a[_i], categoryName = _b[0], tags = _b[1];
                    tags.forEach(function (tag) {
                        filterTags_1.push(tag);
                    });
                }
                var filterTagsNotAssignedToAnyNode = filterTags_1.filter(function (x) { return !validTags.includes(x); });
                var filterTagsNotAssignedToAnyNodeMap = this.mapFilterTagsNotAssignedToAnyNode(filterTagsNotAssignedToAnyNode);
                for (var _c = 0, _d = Object.entries(filterTagsNotAssignedToAnyNodeMap); _c < _d.length; _c++) {
                    var _e = _d[_c], categoryName = _e[0], tags = _e[1];
                    if (filterBy.tags[categoryName].length == filterTagsNotAssignedToAnyNodeMap[categoryName].length) {
                        treeHide = true;
                        break;
                    }
                }
                this.treeViewFiltersHeader = formatTreeviewFilterHeader(this.currentFilterLogic);
            }
            else {
                this.currentFilterLogic = null;
                this.treeViewFiltersHeader = '';
            }
            if (treeHide) {
                tree_filter_1.hideTree(this.treeData);
            }
            else {
                // filterLogic.filter(new Set(validTags));
                // this.currentFilterLogic = filterLogic.toExp();
                var filterBy = tree_filter_1.getFilterBy(this.currentFilterLogic);
                tree_filter_1.filterTree(this.treeData, filterBy.tags, filterBy.dropdowns);
            }
        };
        JsonTree.prototype.filterTreeSubnodes = function (filterLogicStr) {
            var filterLogic = filter_logic_1.createFilterLogic(filterLogicStr);
            if (filterLogic) {
                this.currentFilterLogic = filterLogic.toExp();
                this.treeViewFiltersHeader = formatTreeviewFilterHeader(this.currentFilterLogic);
                var filterBy = tree_filter_1.getFilterBy(this.currentFilterLogic);
                // filterTree(this.treeData, filterBy.tags, filterBy.dropdowns);
                tree_filter_1.filterNodeMap(this.nodeMap, filterBy.tags, filterBy.dropdowns);
            }
            else {
                this.currentFilterLogic = null;
                this.treeViewFiltersHeader = '';
                var filterBy = tree_filter_1.getFilterBy(this.currentFilterLogic);
                tree_filter_1.filterNodeMap(this.nodeMap, filterBy.tags, filterBy.dropdowns);
            }
        };
        JsonTree.prototype.mapFilterTagsNotAssignedToAnyNode = function (filterTagsNotAssignedToAnyNode) {
            var map = {};
            filterTagsNotAssignedToAnyNode.forEach(function (tag) {
                if (tag.indexOf(':') !== -1) {
                    var category = tag.split(':')[0];
                    if (category in map && map[category].indexOf(tag) == -1) {
                        map[category].push(tag);
                    }
                    else {
                        map[category] = [tag];
                    }
                }
            });
            return map;
        };
        JsonTree.prototype.excludeNodeBy = function (excludedTags) {
            this.currentExcludedFilterTags = excludedTags;
            tree_filter_1.excludeBy(this.treeData, excludedTags);
            if (excludedTags.length > 0) {
                if (this.treeViewFiltersHeader != '') {
                    this.treeViewFiltersHeader += ' , ';
                }
                this.treeViewFiltersHeader += '\nExcluded: [' + excludedTags.toString() + ']';
            }
        };
        JsonTree.prototype.excludeNodeBySubnodes = function (excludedTags) {
            this.currentExcludedFilterTags = excludedTags;
            tree_filter_1.excludeByNodeMap(this.nodeMap, excludedTags);
            if (excludedTags.length > 0) {
                if (this.treeViewFiltersHeader != '') {
                    this.treeViewFiltersHeader += ' , ';
                }
                this.treeViewFiltersHeader += '\nExcluded: [' + excludedTags.toString() + ']';
            }
        };
        JsonTree.prototype.setDefaultTreeViewFilters = function (val) {
            this.defaultTreeViewFilters = val;
        };
        JsonTree.prototype.setDefaultTreeViewExcludeFilters = function (val) {
            this.defaultTreeViewExcludeFilters = val;
        };
        JsonTree.prototype.updateLeafParents = function () {
            this.updateIsDataValidForAdmin();
            this.updateLastRecalc();
        };
        /**
         * map leaf node isDataValid up to portfolio nodes
         */
        JsonTree.prototype.updateIsDataValidForAdmin = function () {
            if (this.treeData.role === 'a') {
                this.recursiveAddIsDataValid(this.treeData);
            }
        };
        JsonTree.prototype.recursiveAddIsDataValid = function (treeNode) {
            if (!treeNode.hasChildren) {
                return treeNode.isDataValid !== false;
            }
            for (var _i = 0, _a = treeNode.children; _i < _a.length; _i++) {
                var child = _a[_i];
                this.recursiveAddIsDataValid(child);
            }
            treeNode.isDataValid = treeNode.children.every(function (n) { return (n.isDataValid !== false); });
        };
        /**
         * map leaf node lastRecalc up to portfolio nodes
         */
        JsonTree.prototype.updateLastRecalc = function () {
            if (this.treeData.role === 'a') {
                this.recursiveAddIsDataValid(this.treeData);
            }
            this.getLastRecalc(this.treeData);
        };
        JsonTree.prototype.getLastRecalc = function (treeNode) {
            if (!treeNode.hasChildren) {
                return treeNode.lastRecalc;
            }
            var lastRecalc = '-';
            for (var _i = 0, _a = treeNode.children; _i < _a.length; _i++) {
                var child = _a[_i];
                var childLastRecalc = this.getLastRecalc(child);
                if (childLastRecalc > lastRecalc) {
                    lastRecalc = childLastRecalc;
                }
            }
            treeNode.lastRecalc = lastRecalc;
            return lastRecalc;
        };
        /**
         * Recursively check if any ancestor of a node is platform.
         * Not include the input node.
         *
         * @param node {TreeNode} Start from this id.
         * @returns {TreeNode} The closest platform found or undefined.
         */
        JsonTree.ancestorIsPlatform = function (node) {
            return node.ancestorIsPlatform();
        };
        /**
         * If this node or any of its ancestors is platform.
         *
         * @param node {TreeNode} Input node id (included).
         * @returns {TreeNode} The closest platform found or undefined.
         */
        JsonTree.ancestorIsPlatformInclude = function (node) {
            return node.ancestorIsPlatformInclude();
        };
        /**
         * Travers through the subtree of input node to see if there
         * is a platform child. Not including the input node. A node
         * may have multiple children which are platforms. If any of
         * these is found, returns true.
         *
         * @param node {TreeNode} Input node id.
         * @returns {TreeNode} The closest platform found or undefined.
         */
        JsonTree.nodeHasPlatformChild = function (node) {
            return node.hasPlatformChild();
        };
        /**
         * Is this node or any of its children is platform.
         *
         * @param node {TreeNode} Input node id (included).
         * @returns {TreeNode} The closest platform found or undefined.
         */
        JsonTree.nodeHasPlatformChildInclude = function (node) {
            return node.hasPlatformChildInclude();
        };
        return JsonTree;
    }());
    treewidget.JsonTree = JsonTree;
})(treewidget || (treewidget = {}));
exports["default"] = treewidget;
//# sourceMappingURL=tree-logic.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/tree/app/js/logic/tree-logic.js